import React from 'react';
const PageTitle = ({title,subTitle}) =>{
    document.title = title + " " + subTitle;
    return(
        <h2 className="heading">{title} {subTitle}</h2>
    )
}

export default PageTitle;